import ListItem from "@components/list-item";
import * as React from "react";

import CheckboxIcon from "./icons/checkbox-icon";
import ModalTitle from "@components/modal-title";
import ModalPadding from "@components/closable-modal/modal-padding";
import { useClosableModal } from "@components/closable-modal/closable-modal-context";
import Spacer from "@components/Spacer";
import Button from "@components/button";
import ClosableModal from "@components/closable-modal/closable-modal";
import { Text } from "dripsy";

function ConfirmContent({
  message,
  value,
  onChange,
}: {
  message: string;
  value: boolean;
  onChange: (v: boolean) => void;
}) {
  const modal = useClosableModal();
  return (
    <>
      <ModalTitle title="Bevestigen" />
      <ModalPadding>
        <Text>{message}</Text>
        <Spacer size="$4" />
        <Button
          onPress={() => {
            onChange(!value);
            modal?.onRequestClose();
          }}
        >
          Ja ik weet het zeker
        </Button>
      </ModalPadding>
    </>
  );
}

function CheckboxListItem({
  title,
  description,
  value,
  onChange,
  disableConfirmationMessage,
}: {
  title: string;
  description?: string;
  value: boolean;
  onChange: (v: boolean) => void;
  disableConfirmationMessage?: string;
}) {
  const [modalVisible, setModalVisible] = React.useState(false);
  const onClose = React.useCallback(() => setModalVisible(false), []);
  return (
    <>
      <ListItem
        left={<CheckboxIcon checked={value} size={24} color="$textGrey" selectedColor="$primary" />}
        title={title}
        description={description}
        onPress={() => {
          if (value === true && disableConfirmationMessage) {
            setModalVisible(true);
            return;
          }
          onChange(!value);
        }}
        maxNumberOfLines={3}
      />
      {disableConfirmationMessage && (
        <ClosableModal isVisible={modalVisible} onRequestClose={onClose}>
          <ConfirmContent message={disableConfirmationMessage} value={value} onChange={onChange} />
        </ClosableModal>
      )}
    </>
  );
}
export default CheckboxListItem;
